<template>
  <el-autocomplete
    placeholder="Offer title"
    v-model="deal"
    :fetch-suggestions="searchDeal"
    :debounce="500"
    :trigger-on-focus="false"
    value="dealId"
    value-key="title"
    @select="onSelect">
    <i class="el-icon-search el-input__icon"
       slot="suffix">
    </i>
  </el-autocomplete>
</template>

<script>
  /* ============
   * Search Deal Component
   * ============
   *
   * Search deal by deal id
   *
   * @select
   */
  import DealProxy from '@/app/proxies/DealProxy'

  export default {
    name: 'search-deal',
    data () {
      return {
        deals: [],
        deal: null,
        timeout: null,
        dealProxy: null
      }
    },
    methods: {
      searchDeal (queryString, cb) {
        this.dealProxy
          .setParameter('title', queryString)
          .submit()
          .then(res => {
            this.deals = res.data
            cb(this.deals)
          })
          .catch(err => {
            console.log(err)
          })
      },
      onSelect (deal) {
        this.$emit('select', deal)
      }
    },
    created () {
      this.dealProxy = new DealProxy()
    }
  }
</script>




// WEBPACK FOOTER //
// src/app/components/deal/Search.vue